import { InjectionToken } from '@angular/core';
import { IOrganizationService } from '../interfaces/IOrganizationService';

export const ORGANIZATION_SERVICE = new InjectionToken<IOrganizationService>('Token for Organization Service');
